'use client';
import { Box } from '@mui/material';
import React, { FC } from 'react';

interface ISliderLabel {
  min: number;
  max: number;
}

const SliderLabel: FC<ISliderLabel> = ({ min, max }: { min: number; max: number }) => {
  const formatPrice = (price: number) => {
    if (!price) return '';
    price /= 1000;
    let toStr = `${Math.round(price)}K`;
    if (price >= 1000) toStr = `${Math.round(price) / 1000}M`;
    return `${toStr} `;
  };
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        fontWeight: 500,
        fontSize: '12px',
        lineHeight: '18px',
        marginTop: '-20px',
        color: '#667085',
      }}
    >
      <Box>{formatPrice(min)}</Box>
      <Box>{formatPrice(max)}</Box>
    </Box>
  );
};

export default SliderLabel;
